import React from 'react';
import { CONDITION_WHEN, WeatherAction, actionText, conditionGlyph, dayLabel } from '../../utils/weather';
import WeatherGlyph from './WeatherGlyph';
import { Chip, NOTE } from './weatherUi';

// What to do about it: one line per notable day ahead and one per shown
// pattern, in the order the backend sent them. No model writes these: the
// backend sends numbers, actionText makes the sentence, and each range names
// the group it belongs to.

export default function ActionsCard({ actions }: { actions: WeatherAction[] }) {
  if (!actions.length) return null;
  return (
    <section aria-labelledby="weather-actions" className="rounded-[14px] border border-[#E6E2DE] bg-white p-6 shadow-card">
      <h2 id="weather-actions" className="font-serif text-lg text-[#2D2A2E]">What to do about it</h2>
      <ol className="mt-3 divide-y divide-[#E6E2DE]">
        {actions.map((a, i) => (
          <li key={`${a.for_date ?? 'any'}-${a.condition}-${i}`} data-action className="flex items-start gap-3 py-3.5">
            <span aria-hidden="true" className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#F0EBF5] text-[#4A2D5E]">
              <WeatherGlyph kind={conditionGlyph(a.condition)} size={18} />
            </span>
            <div className="min-w-0">
              {a.for_date ? (
                <Chip tone="plum" kind="when">{dayLabel(a.for_date)}</Chip>
              ) : CONDITION_WHEN[a.condition] ? (
                <Chip tone="quiet" kind="when">{CONDITION_WHEN[a.condition]}</Chip>
              ) : null}
              <p className="mt-1 max-w-[65ch] font-sans text-sm leading-[1.6] text-[#2D2A2E]">{actionText(a)}</p>
            </div>
          </li>
        ))}
      </ol>
      <p className={`${NOTE} mt-1`}>From the patterns on this page. Each one is sized from the cautious end of its range.</p>
    </section>
  );
}
